import { useApprovalFlowContext } from '@mint-lib/approval-flow-circuit';

import { useIsSelectedPlanLocked } from './useGetBuyingPlanData.js';
import { useSelectedBuyingPlanId } from './useSelectedBuyingPlanId.js';

const useIsBuyingPlanLocked = () => {
  const selectedPlanId = useSelectedBuyingPlanId();
  const isSelectedPlanLocked = useIsSelectedPlanLocked();

  const { approvalFlowData } = useApprovalFlowContext();

  const isApprovalFlowDataAvailable =
    approvalFlowData && 'approvalItemStatus' in approvalFlowData;

  const isApprovalItemStatusPending =
    isApprovalFlowDataAvailable &&
    approvalFlowData.approvalItemStatus === 'progress';

  const isLocked =
    isApprovalItemStatusPending ||
    !selectedPlanId ||
    (!isApprovalFlowDataAvailable && isSelectedPlanLocked);

  return {
    isLocked: !!isLocked,
    isApprovalFlowDataAvailable: !!isApprovalFlowDataAvailable,
  };
};

export default useIsBuyingPlanLocked;
